export const categoryCardData = [
  {
    backgroundColor: '#f38f8b',
    subText: 'made for',
    title: 'Mylo Care',
    img: 'https://images.myloapp.in/NestJsUploads/1697896200595-Care-top-card.webp',
    textColor: '#fff0c7',
    mwebImg:
      'https://images.myloapp.in/NestJsUploads/1701078308271-MicrosoftTeams-image-(26).png',
    deeplink: '/category/mylo-care-7545',
    id: 'fillerContainer',
    desktopId: 'firstStack',
  },
  {
    backgroundColor: '#FED79D',
    subText: 'made for',
    title: 'Mylo Baby',
    img: 'https://images.myloapp.in/NestJsUploads/1697896200592-Baby-top-card.webp',
    textColor: '#bd5a52',
    subTextColor: '#bd5a52',
    mwebImg:
      'https://images.myloapp.in/NestJsUploads/1701078308268-MicrosoftTeams-image-(28).png',
    deeplink: '/category/mylo-baby-7546',
    id: 'myloBaby',
    desktopId: 'myloBaby',
  },
  {
    backgroundColor: '#B4B9BA',
    subText: 'our',
    title: 'Mylo Community',
    img: 'https://images.myloapp.in/NestJsUploads/1697896200596-Community-top-card.webp',
    textColor: '#fff0c7',
    mwebImg:
      'https://images.myloapp.in/NestJsUploads/1701078308270-MicrosoftTeams-image-(27).png',
    deeplink: '/parenting',
  },
];

export const subCategoryTilesData = [
  {
    title: 'Fertility',
    img: '',
    background:
      'https://images.myloapp.in/NestJsUploads/1697091603791-ferility.webp',
    flexBasis: '48%',
    animationClass: 'slideInRight',
  },
  {
    title: 'Haircare',
    img: '',
    background:
      'https://images.myloapp.in/NestJsUploads/1697091603794-Skin.webp',
    flexBasis: '48%',
    animationClass: 'slideInRight',
  },
  {
    title: 'Bath & Body',
    img: '',
    background:
      'https://images.myloapp.in/NestJsUploads/1697091603793-preg-and-new-moms.webp',
    flexBasis: '48%',
    animationClass: 'fadeInBottom',
  },
  {
    title: 'Fertility',
    img: '',
    background:
      'https://images.myloapp.in/NestJsUploads/1697091603791-ferility.webp',
    flexBasis: '48%',
    animationClass: 'slideInRight',
  },
  {
    title: 'Haircare',
    img: '',
    background:
      'https://images.myloapp.in/NestJsUploads/1697091603794-Skin.webp',
    flexBasis: '48%',
    animationClass: 'slideInRight',
  },
  {
    title: 'Bath & Body',
    img: '',
    background:
      'https://images.myloapp.in/NestJsUploads/1697091603793-preg-and-new-moms.webp',
    flexBasis: '48%',
    animationClass: 'fadeInBottom',
  },
  // {
  //     title: "Fertility",
  //     img: "",
  //     background:
  //         "https://images.myloapp.in/NestJsUploads/1697091603791-ferility.webp",
  //     flexBasis: "48%",
  //     animationClass: "slideInRight",
  // },
  // {
  //     title: "Haircare",
  //     img: "",
  //     background:
  //         "https://images.myloapp.in/NestJsUploads/1697091603794-Skin.webp",
  //     flexBasis: "48%",
  //     animationClass: "slideInRight",
  // },

  // {
  //     title: "Wellness",
  //     img: "",
  //     background:
  //         "https://images.myloapp.in/NestJsUploads/1696849737241-Screenshot-2023-10-09-163758.webp",
  //     flexBasis: "100%",
  //     animationClass: "slideInRight",
  // },
  // {
  //     title: "Hygiene",
  //     img: "",
  //     background:
  //         "https://images.myloapp.in/NestJsUploads/1697000928441-Mylo-care-category-tile.webp",
  //     flexBasis: "48%",
  //     animationClass: "slideInRight",
  // },
  // {
  //     title: "Weight",
  //     img: "",
  //     background:
  //         "https://images.myloapp.in/NestJsUploads/1697000928441-Mylo-care-category-tile.webp",
  //     flexBasis: "48%",
  //     animationClass: "slideInRight",
  // },
];

export const downloadAppData = [
  {
    mainBg: '#9ea7aa',
    appBg:
      'https://images.myloapp.in/NestJsUploads/1696932949806-Screenshot-2023-10-10-154532.webp',
    appColor: '#9ea7aa',
  },
  {
    appBg:
      'https://images.myloapp.in/NestJsUploads/1696932949806-Screenshot-2023-10-10-154532.webp',
    mainBg: '#ffe7d2',
    appColor: '#ffe7d2',
  },
  {
    mainBg: '#ffeddf',
    appColor: '#ffeddf',
    appBg:
      'https://images.myloapp.in/NestJsUploads/1696932949806-Screenshot-2023-10-10-154532.webp',
  },
  {
    mainBg: '#ead8ca',
    appColor: '#ead8ca',
    appBg:
      'https://images.myloapp.in/NestJsUploads/1696932949806-Screenshot-2023-10-10-154532.webp',
  },
  {
    mainBg: '#b4cdc8',
    appColor: '#b4cdc8',
    appBg:
      'https://images.myloapp.in/NestJsUploads/1696932949806-Screenshot-2023-10-10-154532.webp',
  },
];

export const footerData = [
  {
    title: 'Mylo Care',
    footerLinks: [
      'Skin',
      'hair',
      'bath & body',
      ' Pregnancy & Mom',
      'Health & wellness',
      ' weight',
      ' fertility',
      'hygiene',
    ],
  },
  {
    title: 'Mylo Baby',
    footerLinks: [
      'Diapers & wipes',
      'Baby Care',
      'Baby Wellness',
      'Baby Gear',
      'Baby Clothing',
      'Feeding & Lactation',
    ],
  },
  {
    title: 'Mylo Community',
    footerLinks: [
      'Parenting',
      'Pregnancy planning',
      'Pregnancy ',
      'Infant',
      'Toddler',
      'Topics',
      'Pregnancy week by week',
      'Baby Names',
    ],
  },
];

export const BrandGridData = [
  {
    logoImg:
      'https://images.myloapp.in/NestJsUploads/1697275690898-Screenshot-2023-10-14-145310.webp',
    tagline: 'Made for personal care',
    subText: 'to make you feel your best',
    brandImg:
      'https://images.myloapp.in/NestJsUploads/1697275690901-Screenshot-2023-10-14-145302.webp',
    cards: [
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697278598768-Screenshot-2023-10-14-154558.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697278598770-Screenshot-2023-10-14-154551.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697278598771-Screenshot-2023-10-14-154542.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697278598771-Screenshot-2023-10-14-154530.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697278598770-Screenshot-2023-10-14-154551.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697278598771-Screenshot-2023-10-14-154530.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697278598768-Screenshot-2023-10-14-154558.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697278598771-Screenshot-2023-10-14-154542.webp',
      },
    ],
    gridSize: 4,
    paddingTop: '120%',
    mobileGridSize: 2,
  },
];

export const babyTextData = {
  logoImg:
    'https://images.myloapp.in/NestJsUploads/1697284703112-Screenshot-2023-10-14-164133.webp',
  tagline: 'Made for your bundle of joy',
  subText: 'to make you feel your best',
  brandImg:
    'https://images.myloapp.in/NestJsUploads/1697446665129-Screenshot-2023-10-14-145302-removebg-preview.webp',
  gridSize: 3,
};

const babyFixedData = [
  {
    cardImg:
      'https://images.myloapp.in/NestJsUploads/1697654275630-Group-1244833187.webp',
  },
  {
    cardImg:
      'https://images.myloapp.in/NestJsUploads/1697654659275-Group-1244833900.webp',
  },
  {
    cardImg:
      'https://images.myloapp.in/NestJsUploads/1697654659274-diaper.webp',
  },
  {
    cardImg:
      'https://images.myloapp.in/NestJsUploads/1697654659275-Group-1244833897.webp',
  },
  {
    cardImg:
      'https://images.myloapp.in/NestJsUploads/1697655018365-Group-1244833898.webp',
  },
];
export const BabyCareDataDesktop = [
  {
    ...babyTextData,
    cards: [
      { cardImg: '' },
      { cardImg: '' },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697654659275-Group-1244833910.webp',
        text: 'Care',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697642478355-Group.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697654275630-Group-1244833187.webp',
        text: 'Wellness',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697713757618-Group-1244834029.webp',
        text: 'clothing',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697654659274-diaper.webp',
        text: 'Diapers',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697654659275-Group-1244833897.webp',
        text: 'Feeding',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697655018365-Group-1244833898.webp',
        text: 'Gear',
      },
    ],
  },
];

export const babyCareDataMobile = [
  {
    ...babyTextData,
    cards: [
      { cardImg: '' },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697657524002-Group.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697656619807-Group-1244833957.webp',
        text: 'Care',
      },

      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697656810170-Group-1244833964.webp',
        text: 'Wellness',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697656810169-Group-1244833959.webp',
        text: 'Gear',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697656810169-Group-1244833960.webp',
        text: 'Clothing',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697656619807-Group-1244833961.webp',
        text: 'Diaper',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697656619807-Group-1244833962.webp',
        text: 'Feeding',
      },
    ],
  },
];

export const BabyCareData = [
  {
    logoImg:
      'https://images.myloapp.in/NestJsUploads/1697284703112-Screenshot-2023-10-14-164133.webp',
    tagline: 'Made for your bundle of joy',
    subText: 'to make you feel your best',
    brandImg:
      'https://images.myloapp.in/NestJsUploads/1697446665129-Screenshot-2023-10-14-145302-removebg-preview.webp',
    gridSize: 3,
    cards: [
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697284416886-Screenshot-2023-10-14-172313.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697284416889-Screenshot-2023-10-14-172307.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697284416890-Screenshot-2023-10-14-172300.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697284416891-Screenshot-2023-10-14-172249.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697284416891-Screenshot-2023-10-14-172242.webp',
      },
      {
        cardImg:
          'https://images.myloapp.in/NestJsUploads/1697654275630-Group-1244833898.webp',
      },
    ],
    paddingTop: '60%',
    bgColor: '#edf2f1',
    mobileGridSize: 2,
  },
];

export const myloCareStaggeredData = [
  {
    offset: '0',
    cards: [
      {
        totalProducts: 20,
        title: 'Health & Wellness',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697654516584-Health-&-wellness.webp',
      },
      {
        totalProducts: 25,
        title: 'Hair',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697654411859-hair.webp',
      },
      {
        totalProducts: 15,
        title: 'Bath & Body',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697654516583-Bath-&-Body.webp',
      },
    ],
  },
  {
    offset: '30px',
    cards: [
      {
        totalProducts: 17,
        title: 'Feeding',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697654516584-Feeding.webp',
      },
      {
        totalProducts: 22,
        title: 'Skin',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697654650618-Skin.webp',
      },
      {
        totalProducts: 12,
        title: 'New Moms',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697654516585-New-moms.webp',
      },
    ],
  },
  {
    offset: '100px',
    cards: [
      {
        totalProducts: 16,
        title: 'Hygiene',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697654516585-Hygiene.webp',
      },
      {
        totalProducts: 7,
        title: 'Weight',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697654650619-Weight.webp',
      },
      {
        totalProducts: 11,
        title: 'Pregnancy',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697654650619-Skin2.webp',
      },
    ],
  },
];
export const myloCareStaggeredDataMobile = [
  {
    offset: '0',
    cards: [
      {
        totalProducts: 20,
        title: 'Health & Wellness',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697659612608-Group-1244834011.webp',
      },
      {
        totalProducts: 25,
        title: 'Hair',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697659612610-Group-1244834021.webp',
      },
      {
        totalProducts: 15,
        title: 'Bath & Body',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697659612610-Group-1244834023.webp',
      },
      {
        totalProducts: 7,
        title: 'Weight',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697659612609-Group-1244834017.webp',
      },
      {
        totalProducts: 11,
        title: 'Pregnancy',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697659612611-Group-1244834024.webp',
      },
    ],
  },
  {
    offset: '30px',
    cards: [
      {
        totalProducts: 17,
        title: 'Feeding',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697659738245-healthWellnessM.webp',
      },
      {
        totalProducts: 22,
        title: 'Skin',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697659738245-SkinM.webp',
      },
      {
        totalProducts: 12,
        title: 'New Moms',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697659738245-weightM.webp',
      },
      {
        totalProducts: 16,
        title: 'Hygiene',
        dwebImage:
          'https://images.myloapp.in/NestJsUploads/1697659738244-HairM.webp',
      },
    ],
  },
];

export const titleImageMapping = {
  6186: 'https://images.myloapp.in/NestJsUploads/1697813261236-dweb_care_hair.webp',
  7511: 'https://images.myloapp.in/NestJsUploads/1697813261236-dweb_care_hair.webp',
  6997: 'https://images.myloapp.in/NestJsUploads/1697813261235-dweb_care_bath-and-body.webp',
  7567: 'https://images.myloapp.in/NestJsUploads/1697813261235-dweb_care_bath-and-body.webp',
  7005: 'https://images.myloapp.in/NestJsUploads/1697813261236-dweb_care_fertility.webp',
  7517: 'https://images.myloapp.in/NestJsUploads/1697813261236-dweb_care_fertility.webp',
  5356: 'https://images.myloapp.in/NestJsUploads/1697813247880-dweb_care_skin.webp',
  7510: 'https://images.myloapp.in/NestJsUploads/1697813247880-dweb_care_skin.webp',
  7003: 'https://images.myloapp.in/NestJsUploads/1697813247877-dweb_care_hygiene.webp',
  7568: 'https://images.myloapp.in/NestJsUploads/1697813247877-dweb_care_hygiene.webp',
  6999: 'https://images.myloapp.in/NestJsUploads/1697813247881-dweb_care_weight.webp',
  7516: 'https://images.myloapp.in/NestJsUploads/1697813247881-dweb_care_weight.webp',
  7004: 'https://images.myloapp.in/NestJsUploads/1697813247880-dweb_care_pregnancy-and-new-moms.webp',
  7569: 'https://images.myloapp.in/NestJsUploads/1697813247880-dweb_care_pregnancy-and-new-moms.webp',
  7002: 'https://images.myloapp.in/NestJsUploads/1697813261237-dweb_care_health-and-wellness.webp',
  7515: 'https://images.myloapp.in/NestJsUploads/1697813261237-dweb_care_health-and-wellness.webp',
  7022: 'https://images.myloapp.in/NestJsUploads/1697830667385-dweb_baby-care.webp',
  7505: 'https://images.myloapp.in/NestJsUploads/1697830667385-dweb_baby-care.webp',
  7023: 'https://images.myloapp.in/NestJsUploads/1697830667386-dweb_baby-wellness.webp',
  7566: 'https://images.myloapp.in/NestJsUploads/1697830667386-dweb_baby-wellness.webp',
  7025: 'https://images.myloapp.in/NestJsUploads/1697830667385-dweb_baby-clothing.webp',
  7508: 'https://images.myloapp.in/NestJsUploads/1697830667385-dweb_baby-clothing.webp',
  7021: 'https://images.myloapp.in/NestJsUploads/1697830667388-dweb_diaper-and-wipes.webp',
  7504: 'https://images.myloapp.in/NestJsUploads/1697830667388-dweb_diaper-and-wipes.webp',
  7063: 'https://images.myloapp.in/NestJsUploads/1697830750352-dweb_feeding-and-lactation.webp',
  7506: 'https://images.myloapp.in/NestJsUploads/1697830750352-dweb_feeding-and-lactation.webp',
  7024: 'https://images.myloapp.in/NestJsUploads/1697830667386-dweb_baby-gear.webp',
  7507: 'https://images.myloapp.in/NestJsUploads/1697830667386-dweb_baby-gear.webp',
  mascot:
    'https://images.myloapp.in/NestJsUploads/1697951417763-MicrosoftTeams-image-(15).webp',
};

export const titleMappingMob = {
  6186: 'https://images.myloapp.in/NestJsUploads/1697818055519-care_hair.webp',
  7511: 'https://images.myloapp.in/NestJsUploads/1697818055519-care_hair.webp',
  6997: 'https://images.myloapp.in/NestJsUploads/1697818055516-care_bath-and-body.webp',
  7567: 'https://images.myloapp.in/NestJsUploads/1697818055516-care_bath-and-body.webp',
  6999: 'https://images.myloapp.in/NestJsUploads/1697818067645-care_weight.webp',
  7516: 'https://images.myloapp.in/NestJsUploads/1697818067645-care_weight.webp',
  7004: 'https://images.myloapp.in/NestJsUploads/1697818067644-care_pregnancy-and-new-moms.webp',
  7569: 'https://images.myloapp.in/NestJsUploads/1697818067644-care_pregnancy-and-new-moms.webp',
  7005: 'https://images.myloapp.in/NestJsUploads/1697818055519-care_fertility.webp',
  7517: 'https://images.myloapp.in/NestJsUploads/1697818055519-care_fertility.webp',
  5356: 'https://images.myloapp.in/NestJsUploads/1697818067644-care_skin.webp',
  7510: 'https://images.myloapp.in/NestJsUploads/1697818067644-care_skin.webp',
  7003: 'https://images.myloapp.in/NestJsUploads/1697818067643-care_hygiene.webp',
  7568: 'https://images.myloapp.in/NestJsUploads/1697818067643-care_hygiene.webp',
  7002: 'https://images.myloapp.in/NestJsUploads/1697818055522-care_health-and-wellness.webp',
  7515: 'https://images.myloapp.in/NestJsUploads/1697818055522-care_health-and-wellness.webp',
  7022: 'https://images.myloapp.in/NestJsUploads/1697830498369-baby-care.webp',
  7505: 'https://images.myloapp.in/NestJsUploads/1697830498369-baby-care.webp',
  7023: 'https://images.myloapp.in/NestJsUploads/1697830498372-baby-wellness.webp',
  7566: 'https://images.myloapp.in/NestJsUploads/1697830498372-baby-wellness.webp',
  7024: 'https://images.myloapp.in/NestJsUploads/1697830498372-baby-gear.webp',
  7507: 'https://images.myloapp.in/NestJsUploads/1697830498372-baby-gear.webp',
  7025: 'https://images.myloapp.in/NestJsUploads/1697830498371-baby-clothing.webp',
  7508: 'https://images.myloapp.in/NestJsUploads/1697830498371-baby-clothing.webp',
  7021: 'https://images.myloapp.in/NestJsUploads/1697830498373-diaper-and-wipes.webp',
  7504: 'https://images.myloapp.in/NestJsUploads/1697830498373-diaper-and-wipes.webp',
  7063: 'https://images.myloapp.in/NestJsUploads/1697830578079-feeding-and-lactation.webp',
  7506: 'https://images.myloapp.in/NestJsUploads/1697830578079-feeding-and-lactation.webp',
  mascot: 'https://images.myloapp.in/NestJsUploads/1697657524002-Group.webp',
};

export const tagsMapping = {
  5356: ' Acne | Brightening | Anti - Ageing ',
  7510: ' Acne | Brightening | Anti - Ageing ',
  6186: ' Hairfall | Dry & Damaged Hair ',
  7511: ' Hairfall | Dry & Damaged Hair ',
  7005: ' PCOS | Infertility  ',
  7517: ' PCOS | Infertility  ',
  7004: 'Stretch Marks | Maternity Wear | Lactation',
  7569: 'Stretch Marks | Maternity Wear | Lactation',
  7002: 'Immunity | Pain Management',
  7515: 'Immunity | Pain Management',
  6999: 'Weight Management ',
  7516: 'Weight Management ',
  6997: ' Brightening | Moisturising | Anti Tan ',
  7567: ' Brightening | Moisturising | Anti Tan ',
  7003: " UTI's & Infection | Rashes ",
  7568: " UTI's & Infection | Rashes ",
};
